import { account } from './account.js';
import { i18n } from './i18n.js';

/* Enviar una denuncia de contenido al servidor (server/reports.js). No hace falta cuenta: la puede hacer cualquiera. */

export const report = {
    async send(data) {
        try {
            const res = await fetch(account.baseUrl() + '/api/reports/create', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, cache: 'no-store',
                body: JSON.stringify(Object.assign({ lang: i18n.lang, origin: 'app' }, data))
            });
            const json = await res.json().catch(() => null);
            if (!json) return { ok: false, error: 'unavailable' };
            return json.ok ? json : { ok: false, error: json.error || 'unavailable' };
        } catch (e) {
            return { ok: false, error: 'network' };
        }
    }
};
